import { InvoiceSettingsParams } from "@jugl-web/rest-api";
import { TextInput } from "@jugl-web/ui-components/cross-platform";
import { useTranslations } from "@jugl-web/utils";
import { FieldErrors, UseFormRegister } from "react-hook-form";

type StreetFieldProps = {
  register: UseFormRegister<InvoiceSettingsParams>;
  errors: FieldErrors<InvoiceSettingsParams>;
  value: string;
};

const MAX_LENGTH = 100;

export const StreetField = ({ register, errors, value }: StreetFieldProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <TextInput
        placeholder={t({
          id: "common.enter",
          defaultMessage: "Enter",
        })}
        {...register("street", {
          maxLength: {
            value: MAX_LENGTH,
            message: `${value.length}/${MAX_LENGTH}`,
          },
          setValueAs: (inputValue) => inputValue.trim(),
        })}
        isInvalid={!!errors.street}
        label={t({
          id: "invoices.settings.businessInformation.street",
          defaultMessage: "Street",
        })}
        errorMessage={errors.street?.message}
      />
    </div>
  );
};
